// extracted by mini-css-extract-plugin
export default {"tabs":"I7-z","tablist":"J7-z","tablistItem":"K7-z"};